import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import {
  FooterSection,
  FooterGrid,
  Brand,
  BrandText,
  Column,
  ColumnTitle,
  Legal,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => (
  <FooterSection>
    <Container>
      <FooterGrid>
        <Brand>
          <img src="/img/svg/logo.png" alt="Cantos Contabilidad" width="150" height="46" />
          <BrandText>
            {t("Servicios contables y tributarios en Portoviejo, Ecuador.")}
          </BrandText>
        </Brand>

        <Column>
          <ColumnTitle>{t("Contacto")}</ColumnTitle>
          <a
            href="https://wa.me/593998386291?text=Hola,%20me%20estoy%20comunicando%20solicitando%20asistencia%20contable."
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp +593 998 386 291
          </a>
        </Column>

        <Column>
          <ColumnTitle>{t("Ubicación")}</ColumnTitle>
          <span>Portoviejo, Manabí</span>
          <span>Ecuador</span>
        </Column>
      </FooterGrid>

      <Legal>
        © {new Date().getFullYear()} Grupo Contable Cantos
      </Legal>
    </Container>
  </FooterSection>
);

export default withTranslation()(Footer);
